export default {
    api: 'http://10.100.18.2:40005/api',
    reports: 'http://10.100.18.2:40007/genReport'
}



// WEBPACK FOOTER //
// ./src/config.js